var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3'),_c('p'),_c('v-responsive',[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"edliy-box-about",attrs:{"id":"jxgbox1"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }